import React from 'react';
import ScrollEffectWrapper from './ScrollEffectWrapper';
import ProjectCard from './ProjectCard';
import featuredProjects from '../data/featuredProjects';

function FeaturedProjectsSection() {
  return (
    <section className="section featured-projects-section">
      <div className="container">
        <ScrollEffectWrapper animationType="title">
          <div className="section-header">
            <h2 className="section-title">Featured Projects</h2>
            <p className="section-subtitle">My most impactful and innovative work</p>
          </div>
        </ScrollEffectWrapper>

        <div className="featured-projects-grid">
          {featuredProjects.map((project, index) => (
            <ScrollEffectWrapper key={project.title} animationType="slide-up" delay={index * 150}>
              <ProjectCard project={project} featured />
            </ScrollEffectWrapper>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturedProjectsSection;
